import { OUTLOOK_FAVORITES_API_URL } from "./outlookFavoritesServiceConst";
import { makeGetRequest } from "owa-ows-gateway";
import type { MailboxInfo } from "owa-client-types";

export default function getOutlookFavoritesService(mailboxInfo: MailboxInfo): Promise<any> {
    return makeGetRequest(OUTLOOK_FAVORITES_API_URL, undefined /* correlationId */, false /* returnFullResponse */, undefined /* customHeaders */, true /* throwServiceError */, undefined, "getOutlookFavoritesService", mailboxInfo);
}
